import script from "./AdminDashboardBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardBox.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AdminDashboardBox.vue?vue&type=style&index=1&id=967458ee&lang=css"
import "./AdminDashboardBox.vue?vue&type=style&index=2&id=967458ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-967458ee"]])

export default __exports__